var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPumpkin = function SvgPumpkin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: "auto",
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 10.65c.375.867 2.554 1.854 3.179 2.267.624.413 1.297.623 1.957.784 2.755.68 5.649.644 7.953-1.225l2.06-1.694c-.63-.105-3.302-1.736-3.913-2.065a3.507 3.507 0 0 1-1.569-1.736c-.402-.946-.437-2.143-.152-3.074.035-.105.07-.203.11-.3.147-.35.209-.743.195-1.142a3.02 3.02 0 0 0-.375-1.4 2.229 2.229 0 0 0-.16-.252 1.718 1.718 0 0 0-.353-.357s-.014-.007-.021-.014c-.25-.19-.507-.385-.77-.427-.34-.05-.66.154-.923.434-.805.847-1.18 2.331-1.437 3.78-.257 1.456-.437 2.983-.971 4.222-.68 1.568-3.498 2.15-4.81 2.205v-.007Z",
    fill: "#715D98"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.89 10.992a4.395 4.395 0 0 0 1.596 1.925c.631.413 1.297.623 1.957.784 1.332.33 2.7.49 4.018.364-.61-.07-1.222-.182-1.832-.336-.66-.16-1.326-.371-1.957-.784a4.408 4.408 0 0 1-1.603-1.925c1.311-.056 2.547-.98 3.227-2.556.534-1.232.714-2.765.971-4.214.23-1.323.57-2.674 1.236-3.543a1.55 1.55 0 0 0-.264-.259c-.007 0-.014-.007-.021-.014-.25-.189-.5-.385-.77-.427-.34-.049-.66.154-.923.434-.805.848-1.18 2.332-1.437 3.78-.257 1.457-.43 2.983-.972 4.222-.68 1.569-1.922 2.493-3.226 2.549Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74 11.055c.542-.182.965-.728 1.243-1.421.569-1.45.465-3.284.721-4.915.125-.798.375-1.477.632-2.17.174-.476.333-.96.423-1.485a2.229 2.229 0 0 0-.16-.252c-.09.687-.326 1.289-.548 1.884-.242.665-.45 1.33-.555 2.086-.11.784-.145 1.59-.222 2.387-.139 1.477-.493 3.235-1.568 3.599-.118.042-.077.322.035.287Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.774 9.676c.27-.505.444-1.107.527-1.758.077-.602.049-1.21-.02-1.84-.077-.638-.14-1.275.034-1.856.194-.665.57-1.148.819-1.75 0-.168-.02-.33-.049-.49-.118.399-.305.735-.479 1.07-.2.365-.395.743-.506 1.198-.139.567-.076 1.183-.007 1.792.076.651.111 1.274.014 1.904a4.81 4.81 0 0 1-.486 1.548c-.07.14.083.322.16.182h-.007ZM20.954 10.25c.535-.812.791-1.996.694-3.2-.014-.182.174-.21.188-.028.104 1.31-.174 2.577-.757 3.459-.083.126-.208-.112-.125-.231ZM18.588 4.663c.187-.868.243-1.82.493-2.646.208-.68.548-1.289 1.047-1.485.118-.042.202.224.084.266-1.131.441-1.152 2.59-1.45 3.984-.035.168-.216.049-.181-.12h.007ZM18.54 8.814c.582-.889.72-2.226.825-3.458.111-1.246.222-2.534.722-3.528.07-.14.229.042.16.182-1.02 2.016-.368 5.18-1.583 7.035-.083.127-.208-.112-.125-.23ZM17.873 9.487c.118-1.324.34-2.605.666-3.823.042-.16.222-.042.18.12-.319 1.19-.534 2.45-.652 3.752-.014.175-.208.126-.194-.05Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.962 24.223C40.962 32.001 35.597 37 28.977 37c-.632 0-1.256-.049-1.86-.133a11.781 11.781 0 0 1-2.485-.644c-1.346.511-2.81.777-4.337.777-1.319 0-2.582-.203-3.768-.581-.916.287-1.881.476-2.873.546-.292.021-.59.035-.896.035C6.145 37 .78 32.001.78 24.223S6.145 8.821 12.765 8.821c.583 0 1.152.056 1.714.175.708.14 1.395.372 2.055.673a8.958 8.958 0 0 1 3.768-.848c1.527 0 2.998.407 4.337 1.128.576-.308 1.173-.56 1.784-.75a8.718 8.718 0 0 1 2.554-.385c6.62 0 11.985 7.617 11.985 15.402v.007Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.644 9.41c-1.465 0-2.873.392-4.157 1.085-1.291-.693-2.693-1.085-4.157-1.085a8.53 8.53 0 0 0-3.61.812c-1.137-.518-2.352-.812-3.608-.812-6.357 0-11.5 7.302-11.5 14.757 0 7.456 5.143 12.245 11.486 12.245 1.263 0 2.478-.19 3.609-.553a11.8 11.8 0 0 0 3.609.553c1.464 0 2.873-.26 4.157-.75 1.29.484 2.692.75 4.157.75 6.343 0 11.485-4.789 11.485-12.245 0-7.456-5.142-14.757-11.485-14.757h.014Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.703 24.377c0 5.776-2.644 10.18-6.58 12.483a11.784 11.784 0 0 1-2.484-.644c-1.346.511-2.81.777-4.337.777-1.319 0-2.582-.203-3.768-.581-.916.287-1.881.476-2.873.546C9.62 34.676 6.9 30.23 6.9 24.37c0-6.251 3.095-12.412 7.585-15.38.708.14 1.395.37 2.055.672a8.958 8.958 0 0 1 3.768-.848c1.527 0 2.998.406 4.337 1.128a10.15 10.15 0 0 1 1.784-.75c4.323 3.046 7.273 9.067 7.273 15.171v.014Z",
    fill: "url(#pumpkin_svg__a)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.28 24.223C32.28 32.001 26.916 37 20.295 37 13.675 37 8.31 32.001 8.31 24.223S13.674 8.821 20.295 8.821c6.62 0 11.985 7.617 11.985 15.402Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.78 24.167c0 7.456-5.142 12.245-11.485 12.245-6.343 0-11.485-4.789-11.485-12.245 0-2.373.52-4.732 1.436-6.84 1.957-4.522 5.726-7.917 10.049-7.917 4.323 0 8.092 3.395 10.049 7.918a17.295 17.295 0 0 1 1.436 6.84Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.587 20.016c.055.329-.66 1.218-.847 1.484-.34.476-.729.917-1.152 1.323-.847.805-3.373 2.541-3.373 2.541s.41 1.296.375 1.373c-.035.063-2.304.58-3.2.609-.103-.567-.207-1.127-.312-1.694-.638.09-2.526.02-2.526.02l-.305 1.702a12.293 12.293 0 0 1-2.825-.938c.077-.448.16-.903.236-1.352-2.435-.518-4.774-1.456-6.405-3.304.77 7.638 7.516 10.06 12.172 9.458 2.29-.294 4.456-1.596 5.941-3.36 1.79-2.121 2.734-5.09 2.22-7.855v-.007Z",
    fill: "url(#pumpkin_svg__b)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.35 17.328c-1.956 3.78-5.725 6.006-10.048 6.006-4.324 0-8.092-2.226-10.049-6.006 1.957-4.523 5.725-7.918 10.049-7.918 4.323 0 8.092 3.395 10.049 7.918Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 18.175c-.069-.098-1.568-1.373-2.692-2.31a1.494 1.494 0 0 0-2.228.335c-.014.028-.028.05-.035.063-.52 1.183-.756 2.598-.18 3.823.333.707.95 1.26 1.721 1.4 1.457.266 2.693-.96 3.296-2.156.18-.364.34-.812.118-1.155Z",
    fill: "url(#pumpkin_svg__c)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.22 18.084c-.063-.098-1.471-1.288-2.526-2.17a1.408 1.408 0 0 0-2.096.314c-.014.028-.028.042-.035.056-.486 1.114-.715 2.444-.166 3.592.312.665.895 1.183 1.617 1.316 1.367.245 2.526-.903 3.095-2.023.173-.343.32-.763.11-1.085Z",
    fill: "#3C3334"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 18.189c.063-.105 1.555-1.38 2.679-2.332a1.5 1.5 0 0 1 2.235.322l.034.063c.528 1.183.77 2.598.202 3.823-.334.707-.944 1.267-1.708 1.414-1.457.273-2.7-.945-3.31-2.135-.187-.364-.347-.812-.125-1.155H22.8Z",
    fill: "url(#pumpkin_svg__d)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.974 18.098c.062-.098 1.464-1.296 2.512-2.192a1.407 1.407 0 0 1 2.096.301c.014.028.028.042.034.056.493 1.106.73 2.437.188 3.592-.312.665-.888 1.19-1.603 1.323-1.367.259-2.533-.89-3.11-2.002-.173-.336-.325-.763-.117-1.085v.007ZM21.01 22.431a1.88 1.88 0 0 1-1.076.014.756.756 0 0 1-.513-.903c.076-.329.222-.651.437-.952a.778.778 0 0 1 1.277.02c.187.281.319.568.41.848a.784.784 0 0 1-.528.973h-.007Z",
    fill: "#3C3334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.712 19.56c.055.33-.66 1.219-.847 1.485a9.45 9.45 0 0 1-1.152 1.323c-.847.805-3.74 2.626-3.74 2.626s.409 1.295.374 1.372c-.035.063-1.936.497-2.831.525l-.313-1.694c-.638.09-2.526.02-2.526.02l-.305 1.702a12.285 12.285 0 0 1-2.825-.938c.077-.449.16-.904.236-1.352-2.436-.518-4.774-1.456-6.405-3.304.77 7.638 7.516 10.06 12.172 9.458 2.29-.294 4.456-1.596 5.94-3.36 1.791-2.121 2.735-5.09 2.222-7.855v-.007Z",
    fill: "#3C3334"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkin_svg__a",
    x1: 20.712,
    y1: 5.706,
    x2: 19.984,
    y2: 38.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCE6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F9D3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F7B9B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F39B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EF766C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkin_svg__b",
    x1: 20.455,
    y1: 20.576,
    x2: 20.829,
    y2: 31.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkin_svg__c",
    x1: 14.676,
    y1: 14.685,
    x2: 17.107,
    y2: 24.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkin_svg__d",
    x1: 26.511,
    y1: 14.725,
    x2: 24.145,
    y2: 24.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })))));
};
export default SvgPumpkin;